@if (params?.showEditbtn) {
  <ra-ui-text-button
    class="access-btn"
    [config]="{
      displayIconAfterText: false,
    }"
    icon="ra-icon-ide-sm-edit"
    label="Edit"
    [disabled]="editDisabled"
    [raUiTooltip]="params?.editTooltip"
    [tooltipConfig]="params?.tooltipConfig"
    (click)="btnClickedHandler('edit', $event)"
  >
  </ra-ui-text-button>
}

@if (showRemoveBtn && params?.data.action !== 'remove') {
  <ra-ui-text-button
    class="access-btn"
    [config]="{
      displayIconAfterText: false,
    }"
    icon="ra-icon-ide-sm-delete"
    label="Remove"
    [disabled]="removeDisabled"
    [raUiTooltip]="params?.deleteTooltip"
    [tooltipConfig]="params?.tooltipConfig"
    (click)="btnClickedHandler('remove', $event)"
  >
  </ra-ui-text-button>
}

@if (params?.data.action === 'remove') {
  <ra-ui-text-button
    class="access-btn"
    [config]="{
      displayIconAfterText: false,
    }"
    icon="ra-icon-ide-md-undo"
    label="Undo"
    (click)="btnClickedHandler('undoRemoveAccess', $event)"
  >
  </ra-ui-text-button>
}
